import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'

import TextInput from '../../../../App/Components/Form/TextInput/TextInput'

import { IProps } from './IProps'

export const LastNameInputField: FunctionComponent<IProps> = ({
    setPersonLastName,
}) => {
    const { t } = useTranslation()
    return (
        <div
            style={{
                margin: '0.7em 0',
            }}
        >
            <TextInput
                label={t('Last name')}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setPersonLastName(e.currentTarget.value)
                }}
            />
        </div>
    )
}
